import { Typography } from '@mui/material'
import ActionsList, { IActionListItem } from './ActionsList'
import { useAppSelector } from './RunReduxHooks'
import { selectProcHeader } from './sliceRunProcHeader'

export default function RecruitmentX_30() {
    const procHeader = useAppSelector(selectProcHeader)

    const actions: IActionListItem[] = [
        { field: 'IsBronchoscopyPeformed', altLabel: 'Perform bronchoscopy (optional)' },
        {
            field: 'IsTidalVolumeIncreased',
            altLabel: <>
                Gradually increase lung tidal volume over several breaths to <b>{procHeader!.recruitmentVV_mL!.toFixed(0)} ml</b>
            </>
        },
        { field: 'IsHoldsPerformed', altLabel: 'Perform 3 inspiratory holds for 10 seconds each' },
        {
            field: 'IsTidalVolumeRestored',
            altLabel: <>
                Reset the tidal volume to <b>{procHeader!.steadyStateVV_mL!.toFixed(0)} ml</b>
            </>
        }
    ]

    return (
        <>
            <Typography variant='h6' sx={{ textAlign: 'center' }}>Perform lung recruitment maneuver</Typography>
            <ActionsList
                actions={actions}
                mandatoryFields={[
                    'IsTidalVolumeIncreased',
                    'IsHoldsPerformed',
                    'IsTidalVolumeRestored'
                ]}
            />
        </>
    )
}